import React, { useState } from 'react';
import './shophome.css';

interface Product {
  id: number;
  name: string;
  price: string | number;
  images: string[];
  feature?: string;
}

interface ProductCardProps {
  product: Product;
  onClick: (product: Product) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, onClick }) => {
  const [imageIndex, setImageIndex] = useState<number>(0);

  const nextImage = () => {
    setImageIndex((prev) => (prev + 1) % product.images.length);
  };

  const prevImage = () => {
    setImageIndex((prev) => (prev - 1 + product.images.length) % product.images.length);
  };

  return (
    <div className="product-card" onClick={() => onClick(product)}>
      <div className="image-slider">
        {product.feature && (
          <div className="feature-badge">
            {product.feature}
          </div>
        )}

        <img
          src={product.images[imageIndex]}
          alt={`${product.name} ${imageIndex + 1}`}
        />

        {product.images.length > 1 && (
          <>
            <button
              className="nav-button prev"
              onClick={(e) => {
                e.stopPropagation();
                prevImage();
              }}
            >
              &lt;
            </button>
            <button
              className="nav-button next"
              onClick={(e) => {
                e.stopPropagation();
                nextImage();
              }}
            >
              &gt;
            </button>
          </>
        )}
      </div>

      <div className="product-info">
        <div
          className="product-name"
          style={{ whiteSpace: 'pre-line' }}
        >
          {product.name}
        </div>
        <div className="product-price">{product.price}</div>
      </div>
    </div>
  );
};

export default ProductCard;
